import CCButton from './CCButton';

export default CCButton;
